// Module
var code = "<span class=\"oval-tag {{$ctrl.type}}\"> {{$ctrl.content}} </span> ";
// Exports
module.exports = code;